<div class="row paddingLeft4x">
    <div class="alignTooltips">
        <prism-ui-copy>
            <label>
                {{lifeAmountMultipleElement?.label}}
            </label>
        </prism-ui-copy>
        <div class="toolTipLeftPadding">
            <prism-ui-icon-button
                expanded="false"
                has-tooltip="true"
                icon-name="circle-info"
                is-inactive="false"
                is-waiting="false"
                key-id="{{lifeAmountMultipleElement.tooltip}}"
                label="{{lifeAmountMultipleToolTipDescription}}"
                size="small"
                [tooltipPosition]="multipleOfSalaryTooltipPosition"
                type="button"
                variant="tertiary"
            >
                <div class="multipleOfSalaryTooltipWidth">
                    <prism-ui-copy key-id="multipleOfSalaryTooltip">{{lifeAmountMultipleToolTipDescription}}</prism-ui-copy>
                </div>
            </prism-ui-icon-button>
        </div>
    </div>
</div>
<div class="row paddingBottom paddingLeft4x">
                                            
    <prism-ui-form-field
        [isValid]="formControlUtilitiesService.isControlValid(parentForm, product.key + '_multipleOfSalary')"
        keyId="{{product.key + '_multipleOfSalary'}}"
    >
        <span slot="error">{{ lifeAmountMultipleElement?.error }}</span>

        <prism-ui-select
            slot="input"
            keyId="{{product.key + '_multipleOfSalary'}}"
            has-placeholder="true"
            is-required="true"
            [isValid]="formControlUtilitiesService.isControlValid(parentForm, product.key + '_multipleOfSalary')"
            [options]="multiplesOfSalaryLabels"
            [selectedValue]="getSelectedLabel()"
            ngDefaultControl
            [formGroup]="parentForm"
            formControlName="{{product.key + '_multipleOfSalary'}}"
            (selectEvent)="handleOptionSelected($event, product.key + '_multipleOfSalary')"
        >
        </prism-ui-select>
    </prism-ui-form-field>
    
</div>